import React from 'react';
import { Redirect } from 'react-router-dom';
import { graphql, compose } from 'react-apollo';
import contractByIdQuery from 'ApolloClient/Queries/contractById';
import contractFragment from 'ApolloClient/Fragments/contractFragment';
import updateContractStep2 from 'ApolloClient/Mutations/updateContractStep2';
import signContractByClient from 'ApolloClient/Mutations/signContractByClient';
// LIB
import RecomposeHelpers from 'lib/helpers/RecomposeHelpers';
import queryString from 'query-string';
import ContractPDF from './ContractPDF';
import ContractPageHeader from 'components/common/ContractPageHeader';
import CantFindContract from './CantFindContract';
import moment from 'moment';
import ErrorHelpers from '../../lib/helpers/ErrorHelpers/index';
import notification from 'antd/lib/notification';
import uuidv1 from 'uuid/v1';

const DEFAULT_SALES_TAX = 2;
const DEFAULT_LINE_ITEM = {
  description: '',
  amount: 0,
};

const INITIAL_STATE = {
  keys: [],
  discountType: 'dollar-amount', // 'dollar-amount' or 'percentage'
  contractType: 'Portrait', // 'Portrait', etc
  sessionDate: moment(),
  currency: 'USD',
  finalPaymentAmount: 0,
  finalPaymentDueDate: moment(),
  // createInvoices
  createInvoices: 'dont-create',
  // discount
  discountValue: 0, // discountValue is the percentage or dollar amount of discount
  discountAmount: 0, // discountAmount is based on the discountValue and discountType... dicountValue may be a percentage or a dollar amount... depending on dicountType.
  // deposit
  depositValue: 0,
  depositAmount: 0,
  depositDueDate: moment(),
  depositType: 'dollar-amount', // 'dollar-amount' or 'percentage',
  //
  totalWithTax: DEFAULT_LINE_ITEM.amount * (DEFAULT_SALES_TAX / 100),
  salesTax: DEFAULT_SALES_TAX,
  total: DEFAULT_LINE_ITEM.amount,
  taxAmount: 0,
  subtotalAfterTax: 0,
  subtotal: 0,
  // SIGNATURE
  contractorSignature: null,
  contractorSignDate: null,
  contractorEmail: null,
  clientSignature: null,
  clientSignDate: null,
  clientEmail: null,
};

class ContractSign extends React.PureComponent {
  state = {
    signModalVisible: false,
    step: 1,
    signModalVisible: false,
    contract: {
      ...INITIAL_STATE,
    },
  };

  componentDidMount() {
    this.setContractState(this.props.contractByIdQuery.contractById);
  }

  setContractState = newContractValues => {
    let lineItems = this.formatLineItems(newContractValues.lineItems);
    this.setState({
      contract: {
        ...this.state.contract,
        ...newContractValues,
      },
    });
  };

  formatLineItems = lineItems => {
    // setup the default object that formatLineItems will return
    let lineItemsObj = {
      keys: [],
    };

    // if there are no line items, then we can just return an object with an empty keys array
    if (!lineItems || lineItems.length === 0) {
      return lineItemsObj;
    }

    // if line items exist, foreach over them and create a proprety for each one
    lineItems.forEach(({ amount, description }) => {
      let id = uuidv1();
      // this.setState({ keys: this.state.keys.push(id) })
      lineItemsObj[`names-${id}`] = { amount, description };
      lineItemsObj.keys.push(id);
    });

    return lineItemsObj;
  };

  onCompleteContractor = () => {
    const { match, history } = this.props;
    this.setState({ signModalVisible: !this.state.signModalVisible });

    const variables = {
      _id: match.params._id,
      params: {
        contractorSignature: this.state.contract.contractorSignature,
        contractorSignDate: this.state.contract.contractorSignDate,
      },
    };

    this.props
      .updateContractStep2({
        variables,
        update: (proxy, { data }) => this.postMutationUpdate(proxy, { data }, 'updateContractStep2'),
      })
      .then(() => {
        // notification.success({
        //   message: 'You successfully signed the contract!',
        //   description: "Now it's time to send to your client to be signed.",
        //   duration: 5,
        // });
        history.push(`/contract/view/${match.params._id}`);
      })
      .catch(err => ErrorHelpers.handleError(err));
  };

  postMutationUpdate = (proxy, { data }, mutationName) => {
    // will update local apollo cache after the mutation. see apollo docs.
    const localData = proxy.readFragment({
      id: this.props.match.params._id,
      fragment: contractFragment,
      fragmentName: 'contractFragment',
    });

    proxy.writeFragment({
      fragment: contractFragment,
      fragmentName: 'contractFragment',
      data: {
        ...localData,
        ...data[mutationName],
      },
    });
  };

  onCompleteClient = () => {
    const { match, history } = this.props;
    this.setState({ signModalVisible: !this.state.signModalVisible });

    // const refetchQueries = this.getRefetcQueries();

    const variables = {
      _id: match.params._id,
      params: {
        clientSignature: this.state.contract.clientSignature,
        clientSignDate: this.state.contract.clientSignDate,
      },
    };

    this.props
      .signContractByClient({
        variables,
        update: (proxy, { data }) => this.postMutationUpdate(proxy, { data }, 'signContractByClient'),
      })
      .then(({ data }) => {
        if (data.signContractByClient.invoices && data.signContractByClient.invoices[0]) {
          let invoiceId = data.signContractByClient.invoices[0]._id;
          history.push(`/invoice/pay/${invoiceId}`);
        } else {
          history.push(`/contract/view/${match.params._id}`);
        }
      })
      .catch(err => console.log(err));
    //
  };

  onCompleteSignature = () => {
    // check if there is a user signed in, if so, do a contractor signature. if not, do a client signature
    if (this.props.currentUser && this.props.currentUser._id) {
      this.onCompleteContractor();
    } else {
      this.onCompleteClient();
    }
  };

  toggleSignatureModal = () => {
    this.setState({ signModalVisible: !this.state.signModalVisible });
  };

  onNext = () => {
    this.setState({ step: this.state.step + 1 });
  };

  onBack = () => {
    this.setState({ step: this.state.step - 1 });
  };

  onChange = newValue => {
    this.setState({
      contract: {
        ...this.state.contract,
        ...newValue,
      },
    });
  };

  render() {
    const { match, currentUser } = this.props;
    const { contractById } = this.props.contractByIdQuery;
    let { type } = queryString.parse(this.props.location.search);

    if (!currentUser || !currentUser._id) {
      type = 'client';
    } else {
      type = 'contractor';
    }

    if (!contractById || !contractById._id) {
      return <CantFindContract />;
    }

    // if the user is signed in and the contractorSignature exists, send them to the view page
    if (contractById.contractorSignature && currentUser && currentUser._id) {
      return <Redirect to={`/contract/view/${match.params._id}?type=${type}`} />;
    }

    if (contractById.clientSignature && contractById.contractorSignature) {
      return <Redirect to={`/contract/view/${match.params._id}?type=${type}`} />;
    }

    return (
      <div style={{ width: '100%', height: '100%', maxWidth: '100%' }}>
        <ContractPageHeader current={1} currentUser={this.props.currentUser} />
        <div className="contract-step-container">
          <div style={{ flex: 5, maxWidth: '100%' }}>
            <ContractPDF
              type={type}
              onCompleteSignature={this.onCompleteSignature}
              signatureType={type}
              currentUser={this.props.currentUser}
              onChange={this.onChange}
              signModalVisible={this.state.signModalVisible}
              contract={this.state.contract}
              toggleSignatureModal={this.toggleSignatureModal}
            />
          </div>
          <div style={{ flex: 1 }} />
        </div>
      </div>
    );
  }
}

// APOLLO OPTIONS
// ================================
let options = props => {
  let variables = {
    _id: props.match.params._id,
  };

  return {
    variables,
  };
};

// FINAL EXPORT
// ================================
export default compose(
  graphql(contractByIdQuery, {
    options,
    name: 'contractByIdQuery',
  }),
  graphql(updateContractStep2, {
    name: 'updateContractStep2',
  }),
  graphql(signContractByClient, {
    name: 'signContractByClient',
  }),
  RecomposeHelpers.errorHOC({ propName: 'contractByIdQuery' }),
  RecomposeHelpers.loadingHOC({ propName: 'contractByIdQuery' }),
)(ContractSign);



// WEBPACK FOOTER //
// ./src/routes/contract-sign/index.js